module.exports = __webpack_public_path__ + "static/about-insta-11-a877a8facc87e23561a78572280102b5.jpg";